export var AuditLogTypes;
(function (AuditLogTypes) {
    AuditLogTypes["FUNCTION"] = "Function";
    AuditLogTypes["INTEGRATION"] = "Integration";
    AuditLogTypes["VIEW_ENCRYPTED_USER_IDENTIFIER"] = "View encrypted user identifier";
    AuditLogTypes["VIEW_USER_TYPED"] = "View what the user typed";
    AuditLogTypes["ENCRYPTION_KEY_MANAGEMENT"] = "Encryption key management";
    AuditLogTypes["VIEW_API_ERROR_DETAILS"] = "View encrypted API error details";
    AuditLogTypes["PROJECT_TAG"] = "ProjectTag";
    AuditLogTypes["AUTO_ANONYMISATION_CONFIG"] = "Auto-anonymisation configuration";
})(AuditLogTypes || (AuditLogTypes = {}));
//# sourceMappingURL=audit-log-types.js.map